export const ADD_TO_CART = 'ADD_TO_CART';
export const CALCULATE_PRODUCT_PRICE = 'CALCULATE_PRODUCT_PRICE';
export const CALCULATE_SUB_TOTAL = 'CALCULATE_SUB_TOTAL';
export const COUNT_TOTAL = 'COUNT_TOTAL';
export const DECREMENT_QUANTITY = 'DECREMENT_QUANTITY';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';